import auth from '../auth'
import config from '../config'

export default {
  // ### PROJECTS ###
  async getProjects (limit, offset) {
    const query = {
      limit,
      offset
    }
    const queryString = new URLSearchParams(query).toString()

    return auth.authorizedFetch(config.services.leads.url + '/admin/projects?' + queryString)
  },
  async createProject (name) {
    const options = {}
    options.body = JSON.stringify({ name })

    return auth.authorizedFetch(config.services.leads.url + '/admin/projects', options, 'POST')
  },
  async changeProjectName (id, name) {
    const options = {}
    options.body = JSON.stringify({ name })

    return auth.authorizedFetch(config.services.leads.url + '/admin/projects/' + id, options, 'PUT')
  },
  async disableProject (id) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/projects/' + id + '/disable', {}, 'POST')
  },
  async enableProject (id) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/projects/' + id + '/enable', {}, 'POST')
  },

  // ### FORMS ###
  async getForms (limit, offset, filters) {
    const query = {
      limit,
      offset,
      ...filters
    }
    if (query.projectId === -1) {
      delete query.projectId
    }
    const queryString = new URLSearchParams(query).toString()

    return auth.authorizedFetch(config.services.leads.url + '/views/forms?' + queryString)
  },
  async createForm (form) {
    const options = {}
    const newForm = { ...form }
    newForm.inputs = this.prepareInputs(form.inputs)
    options.body = JSON.stringify(newForm)

    return auth.authorizedFetch(config.services.leads.url + '/admin/forms', options, 'POST')
  },
  async editForm (form) {
    const options = {}
    const newForm = { ...form }
    newForm.inputs = this.prepareInputs(form.inputs)
    options.body = JSON.stringify(newForm)

    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + form.id, options, 'PUT')
  },
  prepareInputs (inputs) {
    const newInputs = {}
    inputs.forEach((input) => {
      newInputs[input.name] = {
        type: input.type,
        rules: input.rules,
        options: input.options
      }
    })
    return newInputs
  },
  async disableForm (formId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId, {}, 'DELETE')
  },
  async enableForm (formId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/enable', {}, 'POST')
  },
  async getForm (formId) {
    return auth.authorizedFetch(config.services.leads.url + '/views/forms/' + formId)
  },

  // ### LEADS ###
  async getLeads (limit, offset, filters) {
    const query = {
      limit,
      offset,
      ...filters
    }
    if (query.projectId === -1) {
      delete query.projectId
    }
    const queryString = new URLSearchParams(query).toString()

    return auth.authorizedFetch(config.services.leads.url + '/views/leads?' + queryString)
  },
  async removeLead (leadId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/leads/' + leadId, {}, 'DELETE')
  },

  // ### SMS NOTIFICATIONS ###
  async createSmsNotification (formId, notification) {
    const options = { body: JSON.stringify(notification) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/sms-notifications', options, 'POST')
  },
  async editSmsNotification (formId, notification) {
    const options = { body: JSON.stringify(notification) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/sms-notifications/' + notification.id, options, 'PUT')
  },
  async pauseSmsNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/sms-notifications/' + notificationId + '/pause', {}, 'POST')
  },
  async activateSmsNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/sms-notifications/' + notificationId + '/activate', {}, 'POST')
  },
  async removeSmsNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/sms-notifications/' + notificationId, {}, 'DELETE')
  },

  // ### EMAIL NOTIFICATIONS ###
  async createEmailNotification (formId, notification) {
    const options = { body: JSON.stringify(notification) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/email-notifications', options, 'POST')
  },
  async editEmailNotification (formId, notification) {
    const options = { body: JSON.stringify(notification) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/email-notifications/' + notification.id, options, 'PUT')
  },
  async removeEmailNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/email-notifications/' + notificationId, {}, 'DELETE')
  },
  async pauseEmailNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/email-notifications/' + notificationId + '/pause', {}, 'POST')
  },
  async activateEmailNotification (formId, notificationId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/email-notifications/' + notificationId + '/activate', {}, 'POST')
  },

  // ### Webhooks ###
  async createWebhook (formId, webhook) {
    const options = { body: JSON.stringify(webhook) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/webhooks', options, 'POST')
  },
  async editWebhook (formId, webhook) {
    const options = { body: JSON.stringify(webhook) }
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/webhooks/' + webhook.id, options, 'PUT')
  },
  async removeWebhook (formId, webhookId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/webhooks/' + webhookId, {}, 'DELETE')
  },
  async pauseWebhook (formId, webhookId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/webhooks/' + webhookId + '/pause', {}, 'POST')
  },
  async activateWebhook (formId, webhookId) {
    return auth.authorizedFetch(config.services.leads.url + '/admin/forms/' + formId + '/webhooks/' + webhookId + '/activate', {}, 'POST')
  }
}
